import {hosts} from '@/api';
import moment from 'moment-timezone';
import {snakeCase} from "@/mixins/static-helpers";

export const dataHelpers = {

	data(){
		return {
			formMsg: []
		}
	},
	computed:{

		breakpoint(){
			return this.$store.getters.breakpoint;
		},
		isMobile(){
			return this.breakpoint.abs < 2;
		},
		isTablet(){
			return this.breakpoint.abs < 3;
		},

	},

	methods: {

		//Short cuts for loading bar
		addLoad(loadName){
			this.$store.commit('addLoad', loadName);
		},
		endLoad(loadName){
			this.$store.commit('endLoad', loadName);
		},
		isLoad(loadName){
			return this.$store.state.loaderList.some( el => el === loadName);
		},


		scrollToQuery(query){
			// eslint-disable-next-line
			$('html, body').animate({
				// eslint-disable-next-line
				scrollTop: $(query).offset().top - document.querySelector('.site-header').getBoundingClientRect().height + 2
			}, 200);
		},


		randomString() {
			function s4() {
				return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
			}
			return (s4()+s4()+"-"+s4()+"-"+s4()+"-"+s4()+"-"+s4()+s4()+s4());
		},
		formatToTime(date){
			return moment(date).format('H[h]mm');
		},
		formatToDate(date, format){
			return moment(date).format(format);
		},

		safeNumber(someTypeValue){
			switch (typeof someTypeValue){
				case 'number':
					return someTypeValue;
				case 'string':
					return parseFloat((someTypeValue).replace(',','.'));
				default:
					return 0;
			}
		},
		formatToMoney(option, commaCount = 2, nbsp = false) {

			const spacer = nbsp ? '&nbsp;' : ' ';
			if(option < 0){
				//I know that this is solution not perfect
				return '-'+this.formatZahl((option * -1) / 100, commaCount) + spacer +'€'
			}else{
				return this.formatZahl(option / 100, commaCount) + spacer +'€';
			}

		},
		formatZahl(zahl, k = true, fix = true) {
			if (!k) k = 0;
			var neu = '';

			// Round
			var f = Math.pow(10, k);
			zahl = '' + parseInt(zahl * f + (.5 * (zahl > 0 ? 1 : -1))) / f;

			// Determine comma
			var idx = zahl.indexOf('.');

			// insert missing zeros
			if (fix) {
				zahl += (idx == -1 ? '.' : '')
					+ f.toString().substring(1);
			}

			// Determine decimal places
			idx = zahl.indexOf('.');
			if (idx == -1) {
				idx = zahl.length;
			}else if(k>0){
				neu = ',' + zahl.substr(idx + 1, k);
			}

			// Thousands separator
			while (idx > 0) {
				if (idx - 3 > 0)
					neu = '.' + zahl.substring(idx - 3, idx) + neu;
				else
					neu = zahl.substring(0, idx) + neu;
				idx -= 3;
			}
			return neu;
		},

		musiqueParser(mus){

			if(typeof mus === 'string'){
				let matches = mus.toLowerCase().match(/[\w]{2,2}/g);

				if(matches){
					for(let m in matches){
						matches[m] = matches[m]
							.replace(/^[A-z]{1}/, el=> el.toUpperCase()) //For unfinished races set first letter to Upper Case
							.replace(/([\d]{2,2})/g, '($1)' ) //For year change wrap year to brackets
					}

					return matches.join('');
				}

				return mus;

			}
			return '';

		},
		snakeCase,
		/*snakeCase(val) {
			if(/\w\+/.test(val)){
				val = val.replace(/(\w)\+/ig, '$1_plus')
			}
			return _.snakeCase(val);
		},*/
		localRandomString() {
			function s4() {
				return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
			}
			return (s4()+s4()+"-"+s4()+"-"+s4()+"-"+s4()+"-"+s4()+s4()+s4());
		},
		encodeImageFileAsURL(event, model, destination = 'file') {
			let filesSelected = event.target.files;

			if (filesSelected.length > 0) {
				for (let i = 0; i < filesSelected.length; i++) {
					let fileToLoad = filesSelected[i];

					let fileReader = new FileReader();

					fileReader.onload = (fileLoadedEvent) => {
						let srcData = fileLoadedEvent.target.result; // <--- data: base64


						model[destination].push({
							name: fileToLoad.name,
							src: srcData
						});

					};
					fileReader.readAsDataURL(fileToLoad);
				}

			}
		},
		silkPath(imagename) {
			if (imagename) {
				let folder = imagename.split('-');

				let date = folder[0];

				date = date.replace(/([\d]{4,4})([\d]{2,2})([\d]{2,2})/, '$1-$2-$3');

				folder = '/silks/' + date + '/';

				return hosts.silks + folder + imagename;
			} else {
				return false;
			}

		},
		sortBettype(array){

			return array.slice().sort((a, b)=>{

				return this.$store.getters.getTypePriorityByName(a.code) - this.$store.getters.getTypePriorityByName(b.code);
			})
		},


		/**
		 * form-message component helper functions
		 * */

		getMessage(scope){

			return this.formMsg.filter((el)=>{
				return el.scope === scope;
			});
		},
		deleteMessage(scope){

			this.formMsg = this.formMsg.filter((el)=>{
				return el.scope !== scope;
			});
		},
		addMessage(objOrScope, state, text){

			if(typeof objOrScope === 'object'){
				this.formMsg.push(objOrScope);
			}else{
				this.formMsg.push({
					scope: objOrScope,
					state: state,
					text: text
				})
			}

		},

		restMessageHandler(status, scope, restMessage, suffix = ''){

			let state;

			switch (status) {
				case 'SUCCESS':
					state = 'success';
					break;
				case 'ERROR':
					state = 'danger';
					break;
				default:
					state = 'warning';
					break;
			}

			let prefix = 'message.';
			if(suffix){
				prefix += suffix+'.';
			}


			if(typeof  restMessage === 'string' ){
				//Specific field error

				this.addMessage( {
					scope: scope,
					state: state,
					text: this.t(prefix+restMessage.replace(/_\((.*?)\)$/, '$1'))
				});
			}else if( Array.isArray(restMessage)){
				//General error

				for(let oneMessage of restMessage){

					let text;
					if(typeof oneMessage.code !== 'undefined'){
						text = oneMessage.code;
					}else{
						text = oneMessage.message;
					}

					text = this.t(prefix+text.replace(/_\((.*?)\)$/, '$1'));

					this.addMessage( {
						scope: scope,
						state: state,
						text: text
					});
				}

			}else if(typeof restMessage === 'object'){
				let text;
				if(typeof restMessage.code !== 'undefined'){
					text = restMessage.code;
				}else{
					text = restMessage.message;
				}
				/*if(typeof restMessage.message !== 'undefined'){
					text = restMessage.message;
				}else{
					text = restMessage.code;
				}*/

				text = this.t(prefix+text.replace(/_\((.*?)\)$/, '$1'));
				this.addMessage( {
					scope: scope,
					state: state,
					text: text
				});
			}
		}

	}
};
